// Full-colour icons from Magnific's "Trading | Gradient" pack (Flaticon,
// Basic Gradient style): Target, Briefcase, Graph, Trading board; the gear is
// from the same style, since the pack has none. The game controller is drawn
// by hand in the pack's two gradients (the pack's own are paid). One hue per page.
import deskIcon from "@/assets/icons/nav/desk.svg";
import tradesIcon from "@/assets/icons/nav/trades.svg";
import performanceIcon from "@/assets/icons/nav/performance.svg";
import playbookIcon from "@/assets/icons/nav/playbook.svg";
import settingsIcon from "@/assets/icons/nav/settings.svg";
import gamesIcon from "@/assets/icons/nav/games.svg";

export interface NavItem {
	path: string;
	label: string;
	/** One word: the page title in the phone top bar. */
	short: string;
	/** URL of a full-colour SVG. */
	icon: string;
	/** Shown under the page title in the top bar. */
	blurb: string;
}

export const NAV_ITEMS: NavItem[] = [
	{ path: "/", label: "Trade Desk", short: "Desk", icon: deskIcon, blurb: "Setups, levels and risk for today's session" },
	{ path: "/trades", label: "Trades", short: "Trades", icon: tradesIcon, blurb: "Open positions and trade journal" },
	{ path: "/performance", label: "Performance", short: "Results", icon: performanceIcon, blurb: "Measured results, net of costs" },
	{ path: "/playbook", label: "Playbook", short: "Playbook", icon: playbookIcon, blurb: "How entries, stops and sessions work" },
	{ path: "/games", label: "Games", short: "Games", icon: gamesIcon, blurb: "Quick practice on real past charts, scored on decisions" },
	{ path: "/settings", label: "Settings", short: "Settings", icon: settingsIcon, blurb: "Account, risk and notifications" },
];

export function navItemFor(pathname: string): NavItem {
	return NAV_ITEMS.find((n) => n.path !== "/" && pathname.startsWith(n.path)) ?? NAV_ITEMS[0]!;
}
